import { render, staticRenderFns } from "./ruleUser.vue?vue&type=template&id=a133b662&scoped=true&"
import script from "./ruleUser.vue?vue&type=script&lang=js&"
export * from "./ruleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a133b662",
  null
  
)

export default component.exports